import breakpoints from 'config/css/breakpoints';

const isDesktop = window.matchMedia(breakpoints['--lgMin']).matches;

export default isDesktop;
